import { Button } from '@mui/material';
import { ReactNode, useEffect, useState } from "react";
import { IScanner } from '../Abstraction/IScanner';
import "./ScannerPreview.scss"

interface IHardwareScannerPreviewProps {
    info?: ReactNode;
    scanner: IScanner;
    isScanning: boolean;
    lastScanTime?: Date;
}   

let lastFadeTime = -1;

export default function HardwareScannerPreview(props: IHardwareScannerPreviewProps) {

    const [isFade, setIsFade] = useState(false);

    const onCancelScan = () => {

        props.scanner.closeAsync();
    }

    useEffect(() => {

        if (props.lastScanTime) {

            setIsFade(false);

            setTimeout(() => setIsFade(true), 0);
            
            const curTime = props.lastScanTime.getTime();
            lastFadeTime = curTime;

            setTimeout(() => {
                if (lastFadeTime == curTime)
                    setIsFade(false);

            }, 3000) as unknown as number;
        }

    }, [props.lastScanTime]);

    return (
        <div className={"scan-preview hardware "
            + (props.isScanning ? "visible" : "hidden")
            + (isFade ? " fade": "")} onClick={ev => ev.preventDefault()}>
            <div className="main">
                Inquadrare un codice
            </div>
            <div className="info">{props.info}</div>
            <Button onClick={onCancelScan} className="cancel-scan">Chiudi</Button>
        </div>
    );
}

